/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Packaging_Count_Log_Approved_Edit_ForbiddenInputs */

const vi_error_packaging_count_log_approved_edit_forbidden = /** @type {(inputs: Error_Packaging_Count_Log_Approved_Edit_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mẻ kiểm kê này đã duyệt. Chỉ người có quyền duyệt phiếu xuất vật tư mới sửa được — nhờ người đó sửa giúp.`)
};

/**

* @param {Error_Packaging_Count_Log_Approved_Edit_ForbiddenInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_packaging_count_log_approved_edit_forbidden = /** @type {((inputs?: Error_Packaging_Count_Log_Approved_Edit_ForbiddenInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Packaging_Count_Log_Approved_Edit_ForbiddenInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_packaging_count_log_approved_edit_forbidden(inputs)
});